/* eslint-env es2020 */

const BASE = 36n;

const sanitizeAlphaNum = value => String(value || '').trim().toLowerCase();

export function encodePublicationId(rawId) {
  const id = sanitizeAlphaNum(rawId);
  if (!id) return '';

  let result = 0n;
  for (let index = 0; index < id.length; index += 1) {
    const char = id[index];
    const parsed = parseInt(char, 36);
    if (Number.isNaN(parsed) || parsed < 0) {
      return '';
    }
    const digit = BigInt(parsed);
    result = result * BASE + digit;
  }
  return result.toString(10);
}

export function decodePublicationId(encodedId) {
  const sanitized = sanitizeAlphaNum(encodedId);
  if (!sanitized) return '';

  let value;
  try {
    value = BigInt(sanitized);
  } catch {
    return '';
  }

  if (value === 0n) {
    return '0';
  }

  let result = '';
  let current = value;
  while (current > 0) {
    const digit = current % BASE;
    result = digit.toString(36) + result;
    current = current / BASE;
  }
  return result;
}

export function isNumericPublicationId(candidate) {
  return /^[0-9]+$/.test(String(candidate || '').trim());
}
